export default "__VITE_ASSET__b98552d9__"